module.exports = __webpack_public_path__ + "img/eiffel.6a981fa9.jpg";